import { ApiResponse } from "admin/src/ui/types/common/api-response";
import { ApiQueryConfig } from "api/types";
import { Product } from "types";

const GetCheckoutDonationProducts: ApiQueryConfig<
  ApiResponse<Product[]>,
  { societyId: string },
  Record<string, unknown>
> = {
  apiPath: "/api/v1/society/{societyId}/accounting/products/checkout-donation",
  queryKey: {
    baseQueryKey: ["GetCheckoutDonationProducts"],
    dynamicQueryKey: ["societyId"],
  },
};

export { GetCheckoutDonationProducts };
